/* =========================================================================
   Aunty Cherish — Install Kit gifts (v2: customer picks 2 of 4)
   Free gifts are $0-priced products, so they're free with NO discount and
   stack cleanly with Mix & Save. Customer picks any 2 of 4 (incl. 2 of the
   same) via an inline picker. If she picks only one and heads to checkout,
   duplicate that chosen gift so the two-gift promise does not break.

   Config (layout/theme.liquid): window.AC_GIFT = {
     threshold: <cents>, property: '_install_kit_gift', maxUnits: 2,
     defaults: [<variantId>, ...], optionIds: [<variantId>, ...]
   }
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.AC_GIFT || {};
  var TIER1 = parseInt(CFG.tier1, 10) || parseInt(CFG.threshold, 10) || 12000;
  var TIER2 = parseInt(CFG.tier2, 10) || 14000;
  // 2026-10-11: no gifts for US / Canada. Doors out of reach, so any gift in the bag is removed.
  if (CFG.off) { TIER1 = Infinity; TIER2 = Infinity; }
  var THRESHOLD = TIER1;
  var FLAG = CFG.property || '_install_kit_gift';
  var MAX = parseInt(CFG.maxUnits, 10) || 2;
  // The Australia Unicorn cart owns its retail gifts. Remove only the old
  // zero-price gift lines when this cart is active, preserving paid items and
  // the existing gift rules in markets still using the theme cart.
  function unicornOwnsGifts() {
    return !!document.querySelector('#unicorn-cart-block .unicorn_cart_4235');
  }
  function allowedUnits(spend) {
    if (unicornOwnsGifts()) return 0;
    if (spend >= TIER2) return MAX;
    if (spend >= TIER1) return 1;
    return 0;
  }
  var DEFAULTS = (CFG.defaults || []).map(Number).filter(Boolean);
  var OPTION_IDS = (CFG.optionIds || []).map(Number).filter(Boolean);
  var TOUCHED = '_gift_touched';

  // Bail only if there's no picker at all. DEFAULTS may be empty (manual-pick mode,
  // 2026-06-06 PM): customer picks both gifts themselves, no auto-default. Aunty
  // Check catches anyone who doesn't pick before ship.
  if (!OPTION_IDS.length) return;

  var busy = false;
  var debounceTimer = null;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Gift line items currently in the cart.
  // 2026-07-10: match a gift line by EITHER our hidden flag OR the variant being one of the
  // configured gift variants (OPTION_IDS). This closes the direct-add leak: the gift products
  // are $0 and were purchasable on their own PDP / via a raw /cart/add.js — a line added that
  // way carries NO flag, so the old flag-only match never saw it and reconcile never stripped
  // it (free gift with no braid spend). Now any gift variant in the bag is treated as a gift
  // line, so if braid spend is under threshold it gets removed like any other unqualified gift.
  function giftLines(cart) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var p = it.properties;
      var flagged = p && (p[FLAG] === 'true' || p[FLAG] === true);
      var isGiftVariant = OPTION_IDS.indexOf(Number(it.variant_id)) !== -1;
      if (flagged || isGiftVariant) {
        out.push({ id: it.variant_id, key: it.key, qty: it.quantity });
      }
    }
    return out;
  }
  function totalUnits(lines) { return lines.reduce(function (s, l) { return s + l.qty; }, 0); }
  function isTouched(cart) { return cart.attributes && (cart.attributes[TOUCHED] === 'true' || cart.attributes[TOUCHED] === true); }

  // 2026-06-13: the Install Kit is gated to AC BRAID spend, not total cart.
  // Founder rule: "$90 of our braids minimum." Stops the margin leak where $90 of
  // thin-margin third-party (gels, etc.) could claim the $74 kit. AC braid =
  // product_type "Pre-Stretched Braiding Hair" (26"/22"/16" + named blends; vendor
  // Aunty Cherish, tag bundle-eligible). Curls/gels/bundles/accessories don't count.
  // Uses final_line_price (post Mix&Save) so 12 packs @ 25% = $90 exactly = kit.
  var BRAID_TYPE = 'Pre-Stretched Braiding Hair';
  function braidSpend(cart) {
    var s = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.product_type === BRAID_TYPE) s += (it.final_line_price != null ? it.final_line_price : it.line_price);
    }
    return s;
  }

  function addUnits(id, qty) {
    var o = { id: id, quantity: qty, properties: {} };
    o.properties[FLAG] = 'true';
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [o] })
    });
  }
  function setQtyByKey(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  function setTouched(val) {
    var attrs = {}; attrs[TOUCHED] = val ? 'true' : '';
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function renderCart() {
    var ajaxForm = document.getElementById('AjaxCartForm');
    if (!ajaxForm) return Promise.resolve();
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSub = doc.getElementById('AjaxCartSubtotal');
        if (newForm) {
          ajaxForm.innerHTML = newForm.innerHTML;
          if (typeof ajaxForm.ajaxifyCartItems === 'function') ajaxForm.ajaxifyCartItems();
        }
        var sub = document.getElementById('AjaxCartSubtotal');
        if (sub && newSub) sub.innerHTML = newSub.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        var total = doc.querySelector('[data-cart-total]');
        if (count) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = count.textContent; });
        if (total) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = total.textContent; });
      });
  }

  // Keep the cart valid: gifts only at/above threshold; default pair on a
  // fresh qualifying cart; never more than MAX units; respect the customer's
  // picks once they've touched the picker.
  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart()
      .then(function (cart) {
        var spend = braidSpend(cart); // BRAID spend only (founder: "$90 of our braids"), not total cart
        var lines = giftLines(cart);
        var units = totalUnits(lines);
        var allowed = allowedUnits(spend);

        if (allowed === 0) {
          if (!lines.length) { if (isTouched(cart)) return setTouched(false); return; }
          return removeAll(lines).then(function () { return setTouched(false); }).then(renderCart);
        }

        // At/above threshold.
        // Auto-add defaults ONLY if DEFAULTS is configured. Empty DEFAULTS = manual-pick
        // mode: customer picks both gifts themselves in the bag (Aunty Check catches misses).
        if (units === 0 && !isTouched(cart) && DEFAULTS.length > 0) {
          return addUnits(DEFAULTS[0], 1)
            .then(function () { return (allowed > 1 && DEFAULTS[1]) ? addUnits(DEFAULTS[1], 1) : null; })
            .then(renderCart);
        }
        if (units > allowed) {
          return trimTo(lines, allowed).then(renderCart);
        }
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function removeAll(lines) {
    return lines.reduce(function (chain, l) { return chain.then(function () { return setQtyByKey(l.key, 0); }); }, Promise.resolve());
  }
  function trimTo(lines, max) {
    var over = totalUnits(lines) - max;
    var ops = [];
    for (var i = lines.length - 1; i >= 0 && over > 0; i--) {
      var take = Math.min(lines[i].qty, over);
      ops.push({ key: lines[i].key, qty: lines[i].qty - take });
      over -= take;
    }
    return ops.reduce(function (chain, o) { return chain.then(function () { return setQtyByKey(o.key, o.qty); }); }, Promise.resolve());
  }

  function completePartialGiftSelection(cart) {
    var lines = giftLines(cart);
    var units = totalUnits(lines);
    var allowed = allowedUnits(braidSpend(cart));
    if (allowed <= 0 || units <= 0 || units >= allowed) return Promise.resolve(false);

    // Safest fallback: duplicate the gift she already chose. This preserves
    // intentional mixes because we only run it at checkout time, not on first tap.
    return addUnits(lines[0].id, allowed - units)
      .then(function () { return setTouched(true); })
      .then(function () { return true; });
  }

  function proceedToCheckout(form) {
    if (form) {
      form.setAttribute('action', '/checkout');
      form.submit();
    } else {
      window.location.href = '/checkout';
    }
  }

  // Picker API — called by the inline +/- buttons in the cart.
  window.acGiftAdjust = function (variantId, delta) {
    variantId = Number(variantId);
    if (OPTION_IDS.indexOf(variantId) === -1) return;
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var allowed = allowedUnits(braidSpend(cart));
      if (allowed === 0) { busy = false; return; }
      var lines = giftLines(cart);
      var units = totalUnits(lines);
      var mine = lines.filter(function (l) { return l.id === variantId; })[0];
      var op;
      if (delta > 0) {
        if (units >= allowed) { busy = false; return; }
        op = mine ? setQtyByKey(mine.key, mine.qty + 1) : addUnits(variantId, 1);
      } else {
        if (!mine) { busy = false; return; }
        op = setQtyByKey(mine.key, mine.qty - 1);
      }
      return op.then(function () { return setTouched(true); }).then(function () { busy = false; return renderCart(); });
    }).catch(function () { busy = false; });
  };

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 220);
  }

  document.addEventListener('add-to-cart', schedule, true);
  document.addEventListener('cart-updated', schedule, true);

  // Header links are styled as buttons. Let Enter/Space use the same click
  // integration as a pointer, without the theme's keyup focusing its hidden
  // legacy drawer. This also covers the cloned sticky header.
  function cartKeyboardHandle(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return null;
    return event.target.closest && event.target.closest('.area--cart');
  }
  document.addEventListener('keydown', function (event) {
    var handle = cartKeyboardHandle(event);
    if (!handle || !unicornOwnsGifts()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!event.repeat) handle.click();
  }, true);
  document.addEventListener('keyup', function (event) {
    if (!cartKeyboardHandle(event) || !unicornOwnsGifts()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  // Delegated handler for the picker +/- buttons (survives cart re-renders).
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-ac-gift-plus]');
    var minus = e.target.closest && e.target.closest('[data-ac-gift-minus]');
    if (plus) { e.preventDefault(); window.acGiftAdjust(plus.getAttribute('data-ac-gift-plus'), 1); }
    else if (minus) { e.preventDefault(); window.acGiftAdjust(minus.getAttribute('data-ac-gift-minus'), -1); }
  }, true);

  document.addEventListener('click', function (e) {
    var checkout = e.target.closest && e.target.closest('[name="checkout"], #CheckOut');
    if (!checkout) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.setTimeout(function () { checkout.click(); }, 250);
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    checkout.setAttribute('aria-busy', 'true');
    checkout.disabled = true;
    busy = true;

    getCart()
      .then(function (cart) { return completePartialGiftSelection(cart); })
      .then(function () { proceedToCheckout(checkout.form || document.getElementById('cart')); })
      .catch(function () { proceedToCheckout(checkout.form || document.getElementById('cart')); })
      .finally(function () {
        busy = false;
        checkout.disabled = false;
        checkout.removeAttribute('aria-busy');
      });
  }, true);

  // Open Unicorn's existing chooser, never add or replace a retail gift here.
  // The app CSS flag is enabled only with its own auto-add setting disabled.
  function initializeGiftChoices(root) {
    if (!root || !root.querySelectorAll || typeof MutationObserver === 'undefined') return;
    var offered = [];
    var choiceTimer;
    function offerChoices() {
      if (getComputedStyle(root).getPropertyValue('--ac-auto-gift-choice').trim() !== '1') return;
      var dialog = document.getElementById('unicorn-cart-dialog');
      if (!dialog || !dialog.open) return;
      var gifts = root.querySelectorAll('.unicorn_cart_unlock_gift');
      for (var i = 0; i < gifts.length; i++) {
        if (gifts[i].classList.contains('unicorn_cart_unlock_gift_before_threshold')) offered[i] = false;
      }
      // Preserve an open product/colour selection, including keyboard focus.
      var popup = root.querySelector('[aria-label="Click to close cart popup"]');
      if (popup && popup.getClientRects().length) return;
      // Choose from the highest earned allowance, rather than mixing two
      // overlapping reward pools. A claimed/dismissed higher tier stays quiet.
      for (var j = gifts.length - 1; j >= 0; j--) {
        if (gifts[j].classList.contains('unicorn_cart_unlock_gift_applied')) return;
        if (!gifts[j].classList.contains('unicorn_cart_unlock_gift_threshold_met')) continue;
        if (offered[j]) return;
        var action = gifts[j].querySelector('.unicorn_cart_unlock_gift_action');
        if (!action || !action.getClientRects().length) continue;
        offered[j] = true; // A dismissed choice stays dismissed for this tier.
        action.click();
        return;
      }
    }
    function queueChoices() {
      clearTimeout(choiceTimer);
      choiceTimer = setTimeout(offerChoices, 180);
    }
    var choicesObserver = new MutationObserver(queueChoices);
    choicesObserver.observe(dialogHost(root), {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open']
    });
    queueChoices();
  }
  function dialogHost(root) {
    return document.getElementById('unicorn-cart-dialog') || root;
  }

  function initialize() {
    reconcile();
    // Unicorn may mount after this deferred theme script. Watch only its own
    // host and stop observing as soon as the Australia cart appears.
    var host = document.getElementById('unicorn-cart-block');
    if (!host || typeof MutationObserver === 'undefined') return;
    if (unicornOwnsGifts()) {
      initializeGiftChoices(document.querySelector('#unicorn-cart-block .unicorn_cart_4235'));
      return;
    }
    var observer = new MutationObserver(function () {
      if (!unicornOwnsGifts()) return;
      observer.disconnect();
      schedule();
      initializeGiftChoices(document.querySelector('#unicorn-cart-block .unicorn_cart_4235'));
    });
    observer.observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
